var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex d-inline-flex"},_vm._l((_vm.model),function(symbol,index){return _c('symbol-switcher',{key:index,attrs:{"config":_vm.config,"enable-null":true},model:{value:(_vm.model[index]),callback:function ($$v) {_vm.$set(_vm.model, index, $$v)},expression:"model[index]"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }